<template>
  <main role="main" class="tmap-v2">
    <portal to="ariane">
      <div class="tbv2-page-title">{{ $t('post.page.choiceviewlistposts.cardview') }}</div>
    </portal>

    <header class="tmap-hero">
      <div class="tmap-hero-text">
        <h1 class="tmap-hero-title">{{ $t('post.page.choiceviewlistposts.cardview') }}</h1>
        <p class="tmap-hero-sub">
          {{ $t('post.page.ticketmap_subtitle') || 'Localisation géographique des tickets.' }}
        </p>
      </div>
      <MultipleListCreate class="tmap-multi-list" />
    </header>

    <div v-if="!loading">
      <section class="tmap-filters">
        <PostsFilters :formTypeId="formTypeId" @filterpost="filterpost" />
      </section>
      <section class="tmap-canvas" :key="'map-dashboard-' + postsWithLocation.length">
        <MapDashboard :posts="postsWithLocation" />
      </section>
    </div>
  </main>
</template>

<script>
import MultipleListCreate from '@/components/UI/MultipleListCreate'
import MapDashboard from '@/components/Model/Map/MapDashboard'
import PostsFilters from '@/components/Model/Post/PostsFilters'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'TicketMap',
  components: {
    MapDashboard,
    MultipleListCreate,
    PostsFilters,
  },
  data: function () {
    return {
      loading: true,
      postconfig: {},
      currentFilter: {},
    }
  },
  created() {
    this.configfilter()
    let postsPromise = this.getPostsLocation(this.currentFilter)
    let postsFiltersPromise = this.getPostsFilters()
    Promise.all([postsPromise, postsFiltersPromise]).then(() => {
      this.loading = false
    })
  },
  computed: {
    config: {
      get() {
        return this.$store.state.post.postsConfig
      },
      set(value) {
        this.$store.commit('post/setPostsConfig', value)
      },
    },
    formTypeId() {
      return this.$route.params.form_type_id || null
    },
    postsWithLocation() {
      return this.posts ? this.posts.data.filter((post) => post.location) : []
    },
    ...mapState('post', {
      posts: (state) => state.myPosts,
    }),
  },
  methods: {
    ...mapActions('post', ['getPostsLocation', 'getPostsFilters']),
    configfilter(search = '') {
      if (search)
        this.currentFilter.search = search;
      this.currentFilter.include = 'answers,medias,form'
      this.currentFilter.filters = { ...this.config.filters }
      this.currentFilter.filters.with_location = ''
      if (this.formTypeId) {
        this.currentFilter.filters.form_type_id = this.formTypeId
      }
      this.currentFilter.per_page = 9999
      this.currentFilter.page = 1
    },
    filterpost(search = '') {
      this.configfilter(search)
      this.getPostsLocation(this.currentFilter).then(() => {
        this.loading = false
      })
    },
  },
  mounted() {},
}
</script>

<style scoped>
.tmap-v2 {
    width: 100%;
    padding: 24px 32px 48px;
    font-family: var(--v2-font-sans);
    color: var(--v2-text-2);
}

.tbv2-page-title {
    font-size: 0.95rem;
    font-weight: var(--v2-font-weight-semibold);
    color: var(--v2-text-1);
    letter-spacing: -0.005em;
}

.tmap-hero {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: var(--v2-space-4);
    margin-bottom: var(--v2-space-5);
}

.tmap-hero-text {
    min-width: 0;
}

.tmap-hero-title {
    margin: 0 0 6px;
    font-size: 1.75rem;
    font-weight: var(--v2-font-weight-bold);
    color: var(--v2-text-1);
    letter-spacing: -0.02em;
    line-height: 1.15;
}

.tmap-hero-sub {
    margin: 0;
    font-size: var(--v2-text-sm-size);
    color: var(--v2-text-3);
    line-height: 1.5;
}

.tmap-multi-list {
    flex-shrink: 0;
}

.tmap-filters {
    background: var(--v2-surface-0);
    border: 1px solid var(--v2-border);
    border-radius: var(--v2-radius-lg);
    margin-bottom: var(--v2-space-4);
}

.tmap-canvas {
    background: var(--v2-surface-0);
    border: 1px solid var(--v2-border);
    border-radius: var(--v2-radius-lg);
    overflow: hidden;
}

@media (max-width: 900px) {
    .tmap-v2 {
        padding: 16px 18px 32px;
    }

    .tmap-hero {
        flex-direction: column;
        align-items: stretch;
        gap: var(--v2-space-3);
    }

    .tmap-hero-title {
        font-size: 1.375rem;
    }
}
</style>
